module.exports = __webpack_public_path__ + "img/photo13.054c3714.jpg";